export default "__VITE_PUBLIC_ASSET__e354802c__"